import MentionSpanTag from "./MentionSpanTag";
import findWithRegex from "find-with-regex";

/**
 * @type {RegExp}
 */
const MENTION_SPAN_REGEX = /(?:\s|^)@[\w]*/g;

/**
 * @type {Object}
 */
const MentionSpanDecoratorConfig = {
  component: MentionSpanTag,
  strategy: (block, callback) => {
    findWithRegex(MENTION_SPAN_REGEX, block, callback);
  },
};

export default MentionSpanDecoratorConfig;
